import './styles.scss';

const NoSeriesPlaceholder = () => {
  return (
    <div className="no-series-placeholder">
      <p>
        No series added.
        <br />
        To add a new one, click on the “Add series” button.
      </p>
    </div>
  );
};

export default NoSeriesPlaceholder;
